import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";var normDateToShortAmericanDate = function normDateToShortAmericanDate(date) {return (
    new Date(date).toLocaleDateString('en-US', { timeZone: 'UTC' }));};

var normDateToLongAmericanDate = function normDateToLongAmericanDate(date) {return (
    new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC'
    }));};

var normDateToAmericanDateTime = function normDateToAmericanDateTime(date) {var _context;
  var convertedDate = new Date(date);
  var rawDate = new Date(convertedDate.getTime() - convertedDate.getTimezoneOffset() * 60 * 1000);
  return _concatInstanceProperty(_context = "".concat(rawDate.toLocaleDateString('en-US'), " @ ")).call(_context, rawDate.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  }));
};

export { normDateToShortAmericanDate, normDateToLongAmericanDate, normDateToAmericanDateTime };
//# sourceMappingURL=dateFormatters.js.map